// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  // ==========================================
  // MÓDULO 1: CART ATTRIBUTES (CHECKOUT ESTÁNDAR)
  // ==========================================
  (function initCartAttributes() {
    "use strict";

    // Funciones privadas para cart attributes
    function getURLParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";
    }

    function getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    }

    function getGclidFromCookie() {
      const gclAw = getCookie("_gcl_aw");
      if (gclAw) {
        const parts = gclAw.split(".");
        return parts[parts.length - 1] || "";
      }
      return "";
    }

    function getTrackingData() {
      return {
        source: getURLParameter("utm_source"),
        medium: getURLParameter("utm_medium"),
        campaign: getURLParameter("utm_campaign"),
        term: getURLParameter("utm_term"),
        content: getURLParameter("utm_content"),
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
        ttp: getCookie("_ttp"),
        ttclid: getCookie("ttclid"),
        gclid: getGclidFromCookie(),
      };
    }

    // Lógica de cart attributes
    const trackingUpdated = sessionStorage.getItem("tracking_updated");

    if (trackingUpdated !== "true") {
      setTimeout(function () {
        try {
          const trackingData = getTrackingData();
          const attributes = { Neosocios: "true" };

          if (trackingData.source) attributes.Source = trackingData.source;
          if (trackingData.medium) attributes.Medium = trackingData.medium;
          if (trackingData.campaign)
            attributes.Campaign = trackingData.campaign;
          if (trackingData.term) attributes.Term = trackingData.term;
          if (trackingData.content) attributes.Content = trackingData.content;
          if (trackingData.fbp) attributes.fbp = trackingData.fbp;
          if (trackingData.fbc) attributes.fbc = trackingData.fbc;
          if (trackingData.ttp) attributes.ttp = trackingData.ttp;
          if (trackingData.ttclid) attributes.ttclid = trackingData.ttclid;
          if (trackingData.gclid) attributes.gclid = trackingData.gclid;

          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes }),
          })
            .then((response) => {
              if (response.ok) {
                // Log de confirmación con datos actualizados
                const updatedFields = Object.keys(attributes).filter(
                  (key) => key !== "Neosocios"
                );
                console.log(
                  `Neosocios: Cart attributes updated - ${
                    updatedFields.length
                  } fields: ${updatedFields.join(", ")}`
                );
                sessionStorage.setItem("tracking_updated", "true");
              }
              return response.json();
            })
            .catch((error) =>
              console.error("Neosocios: Error updating cart attributes:", error)
            );
        } catch (error) {
          console.error("Neosocios: Error in cart attributes module:", error);
        }
      }, 2000);
    }
  })();

  // ==========================================
  // MÓDULO 2: EASYSELL FORM POPULATION
  // ==========================================
  (function initEasySellPopulation() {
    "use strict";

    let easySellPopulated = false;

    function populateEasySellFields() {
      if (easySellPopulated) return;

      try {
        // Obtener datos de tracking de forma totalmente independiente
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("utm_source") || "";
        const medium = urlParams.get("utm_medium") || "";
        const campaign = urlParams.get("utm_campaign") || "";
        const term = urlParams.get("utm_term") || "";
        const content = urlParams.get("utm_content") || "";

        // Función local para cookies
        function getDirectCookie(name) {
          const match = document.cookie.match(
            new RegExp("(^| )" + name + "=([^;]+)")
          );
          return match ? match[2] : "";
        }

        const fbp = getDirectCookie("_fbp");
        const fbc = getDirectCookie("_fbc");
        const ttp = getDirectCookie("_ttp");
        const ttclid = getDirectCookie("ttclid");

        // Obtener gclid localmente
        const gclAw = getDirectCookie("_gcl_aw");
        let gclid = "";
        if (gclAw) {
          const parts = gclAw.split(".");
          gclid = parts[parts.length - 1] || "";
        }

        const fieldsSet = [];

        // Campo Neosocios - SIEMPRE
        const neosociosTextarea = document.querySelector(
          'textarea[placeholder="Neosocios"]'
        );
        if (neosociosTextarea) {
          neosociosTextarea.value = "true";
          ["input", "change"].forEach((event) => {
            neosociosTextarea.dispatchEvent(
              new Event(event, { bubbles: true })
            );
          });
          fieldsSet.push("Neosocios: true");
        }

        // Resto de campos
        const fieldsToCheck = [
          { name: "Source", value: source, placeholder: "Source" },
          { name: "Medium", value: medium, placeholder: "Medium" },
          { name: "Campaign", value: campaign, placeholder: "Campaign" },
          { name: "Term", value: term, placeholder: "Term" },
          { name: "Content", value: content, placeholder: "Content" },
          { name: "fbp", value: fbp, placeholder: "fbp" },
          { name: "fbc", value: fbc, placeholder: "fbc" },
          { name: "ttp", value: ttp, placeholder: "ttp" },
          { name: "ttclid", value: ttclid, placeholder: "ttclid" },
          { name: "gclid", value: gclid, placeholder: "gclid" },
        ];

        fieldsToCheck.forEach((field) => {
          if (field.value && field.value.trim()) {
            const textarea = document.querySelector(
              `textarea[placeholder="${field.placeholder}"]`
            );
            if (textarea) {
              textarea.value = field.value.trim();
              ["input", "change"].forEach((event) => {
                textarea.dispatchEvent(new Event(event, { bubbles: true }));
              });
              fieldsSet.push(`${field.name}: ${field.value}`);
            }
          }
        });

        easySellPopulated = true;

        // Log de confirmación solo si se poblaron campos
        if (fieldsSet.length > 0) {
          console.log(
            `Neosocios: EasySell populated - ${
              fieldsSet.length
            } fields: ${fieldsSet.join(", ")}`
          );
        }
      } catch (error) {
        console.error("Neosocios: Error populating EasySell fields:", error);
      }
    }

    function waitForEasySellForm() {
      // Verificar si el formulario ya existe
      const existingForm = document.querySelector(".es-group");
      if (existingForm) {
        setTimeout(populateEasySellFields, 3000);
        return;
      }

      // MutationObserver con cleanup automático
      let observerDisconnected = false;
      const observer = new MutationObserver((mutations) => {
        if (observerDisconnected) return;

        try {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const easySellForm = node.querySelector
                  ? node.querySelector(".es-group")
                  : null;
                const isEasySellForm =
                  node.matches && node.matches(".es-group");

                if (easySellForm || isEasySellForm) {
                  setTimeout(populateEasySellFields, 3000);
                  observer.disconnect();
                  observerDisconnected = true;
                }
              }
            });
          });
        } catch (error) {
          console.error("Neosocios: Error in EasySell observer:", error);
          observer.disconnect();
          observerDisconnected = true;
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Auto-cleanup después de 30 segundos
      setTimeout(() => {
        if (!observerDisconnected) {
          observer.disconnect();
          observerDisconnected = true;
        }
      }, 30000);
    }

    // Iniciar módulo EasySell
    try {
      waitForEasySellForm();
    } catch (error) {
      console.error("Neosocios: Error initializing EasySell module:", error);
    }
  })();
});